import React from 'react'
import OpenedSvg from '../images/opened'
import ClosedSvg from '../images/closed'
import config from '../../../config'
import Link from '../Link/Link'

const classNameFromDepth = depth =>
  `${depth === 1 ? ' subItem' : depth > 1 ? ' subItem subSubItem' : ''}`

const shouldBeVisible = (node,isExpanded) => {

  if(node.hideInNavigation !== true)
    return true;

  if(isExpanded(node.url))
    return true

  return false;
}

const sort =(a,b) => {
  //no order on any
  if(a.order == null && b.order == null){
    if(a.part > b.part) {return  1;}
    if(a.part < b.part) {return -1;}
  }

  //only a has order
  if(a.order != null && b.order == null)
    return -1

    //only b has order
  if(a.order == null && b.order != null)
    return 1

  if(a.order > b.order) {return  1;}
  if(a.order < b.order) {return -1;}
  
  return 0;
}

const TreeNode = ({
  className = '',
  url,
  title,
  items,
  location,
  expansionSettings,
  toggleExpanded,
  container,
  isExpanded,
  ...rest
}) => {
  const hasChildren = items.length !== 0

  const depth = (url && url.split('/').length - 2) || 0
  const active = location && (location.pathname === url || location.pathname === config.gatsby.pathPrefix + url)

  const isOpen = isExpanded(url)

  const calculatedClassName = `${className} item ${
    active ? 'active' : ''
  }${classNameFromDepth(depth)}`

  return (
    <li className={calculatedClassName}>

      {title && (
        <Link to={url} onClick={(e) => {
            if(!isOpen || container){
              toggleExpanded(url)
            }
            if(container)
              e.preventDefault()
        }}>
          {title}
        </Link>
      )}
      {!config.sidebar.frontLine && title && hasChildren ? (
        <button onClick={() => toggleExpanded(url)} className='collapser'>
          {!isOpen ? <OpenedSvg /> : <ClosedSvg />}
        </button>
      ) : null}

      {(isOpen && hasChildren) || title === undefined ? (
        <ul>
          {items.filter(i => i.url && shouldBeVisible(i,isExpanded)).sort(sort).map((item, i) => (
              <TreeNode key={i + item.url} {...item} location={location} 
                expansionSettings={expansionSettings} 
                toggleExpanded={toggleExpanded} 
                isExpanded={isExpanded}  />
            ))}
        </ul>
      ) : null}
    </li>
  )
}
export default TreeNode
